module.exports = __webpack_public_path__ + "static/media/red-tag-sale-confirmation-background-tablet.d9d2f942.webp";